import {
  CheckTokenType,
  DetailStakingInfoType,
  PossibleUnstakingAmtType,
  ResClaimedListType,
  ResFactoryListType,
  ResPossibleUnstakingAmtType,
  ResPrivateListType,
  ResTokenPriceType,
  ResUserPoolListWithUsdtType,
  ResWaitListType,
  RewardListType,
} from '@/types/staking/read';
import { type CustomAxiosResponse } from '../AxiosResponse';
import { axiosPost } from '../AxiosApi';
import { sendRequest } from '../AxiosRequest';
import { snakeToCamelCase } from '@/lib/convert-code-style';
import { CreateUnstakinguser } from '@/types';
import { POLYGON_AMOY, POLYGON_MAIN } from '@/lib/common/name-space';

// 암호화된 토큰 가격을 가져온다.
export const tokenPrice = async (): Promise<CustomAxiosResponse<ResTokenPriceType>> => {
  const payload = {
    path: `/v1/staking-users/token-price`,
  };
  return sendRequest(payload, 'tokenPrice', axiosPost);
}; // ResTokenPriceType

// 토큰 가격을 서버로 보낸다(보낸 토큰가격과 맞는지 체크)
export const checkToken = async (checkTokenType: CheckTokenType) => {
  const payload = {
    path: `/v1/staking-users/check-token`,
    body: { ...checkTokenType },
  };
  return sendRequest(payload, 'checkToken', axiosPost, true);
};
// 풀 화면 리스트(open, closed)
export const poolList = async () => {
  const payload = {
    path: `/v1/staking-users/list`,
  };
  const re = await sendRequest(payload, 'poolList', axiosPost);
  const open = re.data?.open ? re.data.open.map((item: any) => snakeToCamelCase(item)) : [];
  const closed = re.data?.closed ? re.data.closed.map((item: any) => snakeToCamelCase(item)) : [];
  const other = re.data?.other ? re.data.other.map((item: any) => snakeToCamelCase(item)) : [];
  const result = {
    open,
    closed,
    other,
  };
  return result;
};
// 풀 전체 스테이킹 금액(usdt)
export const totalStakeUsdt = async () => {
  const payload = {
    path: `/v1/staking-users/total-stake-usdt`,
  };
  return sendRequest(payload, 'totalStakeUsdt', axiosPost);
};

// 풀 상세 화면
export const poolDetail = async (poolId: string) => {
  const payload = {
    path: `/v1/staking-users/detail`,
    body: { poolId },
  };
  return sendRequest(payload, 'poolDetail', axiosPost);
};
// 포트폴리오 holds 리스트
export const holdsList = async (address: string): Promise<CustomAxiosResponse<ResUserPoolListWithUsdtType>> => {
  const payload = {
    path: `/v1/staking-users/user-list`,
    body: { address },
  };
  return sendRequest(payload, 'holdsList', axiosPost);
};
// 포트폴리오 언스테이킹 가능한 리스트
export const userStakingList = async (rewardListType: RewardListType) => {
  const payload = {
    path: `/v1/staking-users/user-stake-list`,
    body: { ...rewardListType },
  };
  return sendRequest(payload, 'userStakingList', axiosPost);
};
// 포트폴리오 상세
export const detailStakingInfo = async (joinId: string): Promise<CustomAxiosResponse<DetailStakingInfoType>> => {
  const payload = {
    path: `/v1/staking-users/join-detail`,
    body: { joinId },
  };
  return sendRequest(payload, 'detailStakingInfo', axiosPost);
};

// 포트폴리오 언스테이킹 가능한 물량 조회
export const userUnstaking = async (
  possibleUnstakingAmtType: PossibleUnstakingAmtType,
): Promise<CustomAxiosResponse<ResPossibleUnstakingAmtType>> => {
  const payload = {
    path: `/v1/staking-users/unstake-amount`,
    body: { ...possibleUnstakingAmtType },
  };
  return sendRequest(payload, 'userUnstaking', axiosPost);
};

// 언스테이킹 하기 전 조회
export const checkUnstake = async (aData: CreateUnstakinguser) => {
  const payload = {
    path: `/v1/staking-users/check-unstake`,
    body: { ...aData },
  };
  return sendRequest(payload, 'checkUnstake', axiosPost);
};

// 리워드 리스트
export const rewardList = async (aData: RewardListType): Promise<CustomAxiosResponse<ResWaitListType[]>> => {
  const payload = {
    path: `/v1/staking-user-reward/reward-list`,
    body: { ...aData },
  };
  return sendRequest(payload, 'rewardList', axiosPost);
};

// 클래임 직전 컨트랙트 받어오기
export const getContractAddrByJoinId = async (joinId: string) => {
  console.log(joinId);
  const payload = {
    path: '/v1/staking-user-reward/contract',
    body: { joinId },
  };
  return sendRequest(payload, 'getContractAddrByJoinId', axiosPost);
};

// 클레임 리워드 리스트
export const claimedList = async (aData: RewardListType): Promise<CustomAxiosResponse<ResClaimedListType>> => {
  const payload = {
    path: `/v1/staking-user-reward/claimed-list`,
    body: { ...aData },
  };
  return sendRequest(payload, 'claimedList', axiosPost);
};

// 대기 리워드 리스트
export const expectList = async (poolId: string) => {
  const payload = {
    path: `/v1/staking-user-reward/plan-list`,
    body: { poolId },
  };
  return sendRequest(payload, 'planList', axiosPost);
};
//(회수 할 때만 사용) 토큰 가격을 서버로 보낸다(보낸 토큰가격과 맞는지 체크)
export const checkTokenWithdarw = async (checkTokenType: CheckTokenType) => {
  const payload = {
    path: `/v1/staking-users/check-withdaw`,
    body: { ...checkTokenType },
  };
  return sendRequest(payload, 'checkTokenWithdarw', axiosPost, true);
};

// 팩토리 풀의 컨트랙트 리스트 불러오기
export const factoryContractList = async (
  network: string = process.env.NODE_ENV === 'production' ? String(POLYGON_MAIN) : String(POLYGON_AMOY),
): Promise<CustomAxiosResponse<ResFactoryListType[]>> => {
  const payload = {
    path: `/staking-factory/list`,
    body: { network },
  };
  return sendRequest(payload, 'factoryContractList', axiosPost, true);
};
// 컨트랙트 풀 리스트 불러오기
export const contractList = async (): Promise<CustomAxiosResponse<string[]>> => {
  const payload = {
    path: `/v1/staking-users/contract-list`,
  };
  return sendRequest(payload, 'factoryContractList', axiosPost, true);
};
// 프라이빗 토큰 풀 가져오기
export const privateList = async (): Promise<CustomAxiosResponse<ResPrivateListType[]>> => {
  const payload = {
    path: `/v1/staking-users/private-list`,
  };
  return sendRequest(payload, 'privateList', axiosPost, true);
};
// 회수를 했는지 안했는지 체크 - 회수 했음 회수 버튼 숨김
export const stateWithdraw = async (rewardListType: RewardListType) => {
  const payload = {
    path: `/v1/staking-users/state-withdraw`,
    body: { ...rewardListType },
  };
  return sendRequest(payload, 'stateWithdraw', axiosPost, true);
};
// 회수 목록
export const withdrawResultList = async (rewardListType: RewardListType) => {
  const payload = {
    path: `/v1/staking-users/withdraw-result`,
    body: { ...rewardListType },
  };
  return sendRequest(payload, 'withdrawResultList', axiosPost, false);
};

// 원금 회수가 가능한지 체크
export const isCheckWithdraw = async (poolId: string) => {
  const paylaod = {
    path: `/v1/staking-user-reward/latest-setting`,
    body: { pool_id: poolId },
  };
  return sendRequest(paylaod, 'isCheckWithdraw', axiosPost);
};
// 풀에 스테이킹 한 실제 조회(컨트랙트 조회한 수량)
export const poolAmount = async (contractAddr: string) => {
  const payload = {
    path: `/v1/staking-users/pool-amount`,
    body: { contractAddr },
  };
  return sendRequest(payload, 'poolAmount', axiosPost);
};

export const readVersion = async () => {
  const payload = {
    path: '/version/v1',
    body: {
      name: window.location.host,
    },
  };
  const { data: res } = await axiosPost(payload);
  return res;
};
